export default {
  palette: {
    black: '#222',
    red: '#ce1126',
    lightRed: '#f7495c',
    blueGrey: '#6b7c93',
    lightBlueGrey: '#aab7c4',
    green: '#03b040',
    grey: '#6c6d6c',
    darkRed: '#9e2146',
  },
};



// WEBPACK FOOTER //
// ./src/themes/main.js